import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SpacingWrapper = styled.div.withConfig({
  displayName: "DynamicWidthPropertyLabel__SpacingWrapper",
  componentId: "sc-1gikzfn-0"
})(["padding-block-start:5px;"]);
const DynamicWidthPropertyLabel = ({
  label
}) => {
  return /*#__PURE__*/_jsx(SpacingWrapper, {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      textWrap: "nowrap",
      children: /*#__PURE__*/_jsxs(Flex, {
        as: "span",
        children: [/*#__PURE__*/_jsx(TruncateString, {
          useFlex: true,
          children: label
        }), /*#__PURE__*/_jsx(_Fragment, {
          children: ":\xA0"
        })]
      })
    })
  });
};
export default DynamicWidthPropertyLabel;